/**
 * @description Track event using DY API
 * @param name - The name of the event
 * @param properties - The properties of the event
 * @see https://support.dynamicyield.com/hc/en-us/articles/360023172893-Events
 * @example
 * dyTrack('page_view', { page: 'home' });
 */
export function trackDy(name: string, properties: Record<string, any>) {
  if (typeof window !== 'undefined' && typeof window.DY !== 'undefined' && 'API' in window.DY) {
    window.DY.API('event', {
      name,
      properties: properties,
    });
  }
}

// setSPAContext @todos: 待迁移 @abby 2025-08-27
export function trackDySpa() {
  if (typeof window !== 'undefined' && typeof window.DY !== 'undefined' && 'API' in window.DY) {
    // window.DY.API('spa', {});
  }
}
